export class Registration {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    confirmPassword: string;
    companyName: string;
    countryName: string;
    countryId: number;
    countryCode:string;
    phoneNumber: string;
    isDesktop :boolean;
    mobileIp :string;
    isMobile:boolean;
    desktopIp :string;
    IsTab :boolean;
    TabIp:string;
    captchaResponse:string;
    planId: string |null;
    UtmSource: string| null;
    UtmCampaign: string| null;
    UtmContent: string| null;
    UtmMedium: string| null;
    UtmTerm: string| null;
}


export interface LoginVM {
    UserName: string;
    Password: string;
}

export class UserAccess {
    AccessToken: string;
    ExpiresIn: string;
}

export class ResetPasswordVM {
    userId:string;
    expireTime:string;
    token:string;
    newPassword:string;
    confirmPassword:string;
}